import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponent } from './tabs.component';
import { TabComponent } from './tab/tab.component';

// reference https://juristr.com/blog/2016/02/learning-ng2-creating-tab-component/
@NgModule({
    declarations: [TabComponent, TabsComponent],
    imports: [
        CommonModule
    ],
    exports: [TabComponent, TabsComponent]
})
export class TabsModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/tabs/tabs.module.ts